import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { Work } from "@/components/site/Work";
import { Process } from "@/components/site/Process";
import { Studio } from "@/components/site/Studio";
import { Estimator } from "@/components/site/Estimator";
import { Quote } from "@/components/site/Quote";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-[#111110]">
      <Nav />
      <Hero />
      <Ribbon />
      <Work />
      <Process />
      <Studio />
      <Estimator />
      <Quote />
      <Footer />
    </main>
  );
}
